/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { EditCommissionRatesConfig } from "./EditCommissionRates.formfield.config";

/** Utilities */
import { setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";
import { setDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import ToastService from "../../../../../../../services/toastService/ToastService";
import { format_Date } from "../../../../../../../components/finalMolGrid/libs/formatDate";

/** RTK Query */
import { useAddCommissionRateMutation, useGetAllSalesrepsMutation, useUpdateCommissionRateMutation } from "../../../../../../../app/services/contractAPI";
import PropTypes from "prop-types";

const EditCommissionRates = ({ rowData, commissionRateList, onSaveSuccess }) => {
  const EditCommissionRatesRef = useRef();
  const url = window.location.search;
  const contractId = new URLSearchParams(url).get("contract");
  const [commissionRateForm, setCommissionRateForm] = useState(EditCommissionRatesConfig);

  const [addCommissionRate, {
    isSuccess: isCommissionRateAdded,
    data: commissionRateAddData
  }] = useAddCommissionRateMutation();

  const [updateCommissionRate, {
    isSuccess: isCommissionRateUpdated,
    data: commissionRateUpdateData
  }] = useUpdateCommissionRateMutation();

  const [getAllSalesreps, {
    isSuccess: isAllSalesrepsFetched,
    data: AllSalesrepsData
  }] = useGetAllSalesrepsMutation();

  const SalesrepReq = { pbIncludeBlank: true, psActiveFlag: 'Y' }
  useEffect(() => {
    getAllSalesreps(SalesrepReq);
    setFieldSetting(commissionRateForm, 'lSalesRepKey', FieldSettingType.ISFIELDDATALOADING, true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId])

  useEffect(() => {
    if (isAllSalesrepsFetched && AllSalesrepsData) {
      setDropdownOptions(AllSalesrepsData, 'lSalesRepKey', 'repName', commissionRateForm, 'lSalesRepKey', setCommissionRateForm);
      setFieldSetting(commissionRateForm, 'lSalesRepKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllSalesrepsFetched, AllSalesrepsData])

  useEffect(() => {
    if (isCommissionRateAdded && commissionRateAddData) {
      if (commissionRateAddData) {
        ToastService.success(commissionRateAddData?.errorMessage);
        onSaveSuccess();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCommissionRateAdded, commissionRateAddData]);


  useEffect(() => {
    if (isCommissionRateUpdated && commissionRateUpdateData) {
      if (commissionRateUpdateData) {
        ToastService.success(commissionRateUpdateData?.errorMessage);
        onSaveSuccess();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCommissionRateUpdated, commissionRateUpdateData]);


  useEffect(() => {
    if (rowData) {
      const form = { ...EditCommissionRatesConfig };
      form.initialState = {
        dtEffectiveDate: rowData.dtEffectiveDate ? new Date(rowData.dtEffectiveDate) : null,
        dtEndDate: rowData.dtEndDate ? new Date(rowData.dtEndDate) : null,
        lSalesRepKey: rowData.lSalesRepKey,
        sCommissonRate: parseFloat(rowData.nCommissionRate)
      }
      setCommissionRateForm(form)
    }
  }, [rowData]);

  const extractValue = (field) => {
    return field && typeof field === "object" ? field.value : field;
  };

  const handleSave = () => {
    const formData = EditCommissionRatesRef.current.getFormData();
    if (!formData) return;

    const selectedDate = format_Date(formData.dtEffectiveDate);

    const isDateExists = commissionRateList?.some(item => {
      const itemDate = format_Date(item.dtEffectiveDate);
      const gridRow = rowData && rowData.dtEffectiveDate && format_Date(rowData.dtEffectiveDate) === itemDate;
      return !gridRow && itemDate === selectedDate;
    });

    if (isDateExists) {
      ToastService.error("Invalid date range.This range overlaps other rates.");
      return;
    }

    const request = {
      plContractKey: contractId,
      pdtEffectiveDate: format_Date(formData.dtEffectiveDate),
      pdtEndDate: format_Date(formData.dtEndDate),
      plSalesRepKey: extractValue(formData?.lSalesRepKey),
      pnCommissionRate: parseFloat(formData?.sCommissonRate)
    };

    if (rowData) {
      updateCommissionRate(request);
    } else {
      addCommissionRate(request);
    }
  };

  return (
    <div className="row">
      <FormCreator ref={EditCommissionRatesRef} config={commissionRateForm} />
      <div className="d-flex justify-content-end gap-3 mt-3">
        <Buttons
          buttonText="Save"
          onClick={handleSave}
          buttonTypeClassName="btn blue-btn"
          titleText=""
        />
        <Buttons
          buttonText="Cancel"
          onClick={onSaveSuccess}
          buttonTypeClassName="btn dark-btn"
          titleText="Cancel"
        />
      </div>
    </div>
  );
};
EditCommissionRates.propTypes = {
  commissionRateList: PropTypes.arrayOf(PropTypes.object),
  onSaveSuccess: PropTypes.func,
  rowData: PropTypes.shape({
    dtEffectiveDate: PropTypes.string,
    dtEndDate: PropTypes.string,
    lSalesRepKey: PropTypes.number,
    nCommissionRate: PropTypes.number,
  })
};
export default EditCommissionRates;
